import React, { useEffect, useState } from 'react';
import './ScrollToTopButton.css';

const ScrollToTopButton: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = (e: React.MouseEvent<HTMLButtonElement>) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    e.currentTarget.blur(); // Evita que el botón quede en estado :focus tras hacer clic
  };

  return (
    <button
      className={`scroll-to-top-btn button secondary${visible ? ' visible' : ''}`}
      onClick={scrollToTop}
      aria-label="Subir arriba"
      style={{ fontFamily: 'var(--main-font, inherit)' }}
    >
      <span className="scroll-arrow" aria-hidden="true">
        <svg width="48" height="48" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="40" cy="40" r="36" stroke="currentColor" strokeWidth="4" fill="none" />
          <path d="M40 60V28" stroke="currentColor" strokeWidth="8" strokeLinecap="round"/>
          <path d="M24 40L40 22L56 40" stroke="currentColor" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </span>
    </button>
  );
};

export default ScrollToTopButton;
